import React from "react";
import delevery from "../img/delivery.png";
import HeroBg from "../img/heroBg.png";
import { heroData } from "../utils/Data";

function HomeContainer() {
  return (
    <section
      className="grid grid-cols-1  md:grid-cols-2 gap-2 w-full  "
      id="home"
    >
      <div className="py-2 flex-1 flex flex-col items-start justify-center gap-6 ">
        <div className="flex items-center gap-2 justify-center bg-orange-100  px-4 py-1 rounded-full">
          <p className="text-base text-orange-500 font-semibold drop-shadow-xl">
            Bike Delivery
          </p>
          <div className="w-8 h-8 rounded-full overflow-hidden">
            <img
              className="w-full h-full object-contain bg-white"
              src={delevery}
              alt="delevery"
            />
          </div>
        </div>
        <p className="text-[2rem] md:text-[4.5rem] font-bold tracking-wide text-headingColor">
          The Fastest Delivery in{" "}
          <span className="text-orange-500 text-[3rem]">Your City </span>
        </p>
        <p className="text-base text-textColor text-center md:text-left md:w-[80%]">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos
          quidem quas quasi neque excepturi hic sed beatae id sequi! Inventore,
          voluptatem fugiat! Esse debitis sunt repellat atque nihil dolorum
          beatae.
        </p>
        {/* <button type='button' className='bg-gradient-to-br from-orange-400 to-orange-500 md:w-auto w-full p-4 px-4py-2 rounded-lg hover:shadow-lg  transition-all ease-in-out duration-100 '>Order Now</button> */}
      </div>

      <div className="py-4 flex-1 flex items-center relative">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${HeroBg})`,
            height: "100%",
            width: "100%",
          }}
        ></div>

        <div className="w-full h-full relative flex items-center justify-center lg:px-32 py-4 gap-4 flex-wrap overflow-x-auto">
          {heroData &&
            heroData.map((n) => (
              <div
                key={n.id}
                className="lg:w-190 w-full sm:w-48 md:w-72 p-6 bg-cardOverlay backdrop-blur-md rounded-3xl flex flex-col items-center justify-center drop-shadow-lg"
                style={{
                  
                    // marginBottom: "2.6rem",
                    // marginTop: "1rem"
                }
                }
              >
                <img
                  src={n.imageSrc}
                  className="w-20 lg:w-40 sm:w-32 md:w-36 -mt-10 lg:-mt-25"
                  alt={n.name}
                />
                <p className="text-base lg:text-xl font-semibold text-textColor mt-2 lg:mt-4">
                  {n.name}
                </p>

                <p className="text-[12px] lg:text-sm text-lighttextGray font-semibold my-4 lg:my-3">
                  {n.decp}
                </p>

                {/* <p className="text-sm font-semibold text-headingColor">
                  <span className="text-xs text-red-600">$</span> {n.price}
                </p> */}
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}
export default HomeContainer;
